import React from "react";
import {Moon, Sun} from "@gravity-ui/icons";
import {ControlGroupOption, SegmentedRadioGroup} from '@gravity-ui/uikit';
import './DarkLight.css'; // Import a custom CSS file
import {THEME_MODES, ThemeMode} from '../features/theme/THEME_MODES';

interface DarkLightProps {
    value?: ThemeMode;
    onChange?: (value: ThemeMode) => void;
}

const DarkLight = ({value = THEME_MODES.DARK, onChange}: DarkLightProps) => {

    const IconStyle = {verticalAlign: 'middle', paddingBottom: 2};
    const options: ControlGroupOption<ThemeMode>[] = [
        {
            value: THEME_MODES.LIGHT,
            content: <div><Sun style={IconStyle}/></div>,
            title: `${THEME_MODES.LIGHT} mode`,
        },
        {
            value: THEME_MODES.DARK,
            content: <div><Moon style={IconStyle}/></div>,
            title: `${THEME_MODES.DARK} mode`,
        },
    ];

    return (
        <SegmentedRadioGroup<ThemeMode>
            value={value}
            options={options}
            onUpdate={onChange}
            size="l"
            style={{width: '100%'}}
            className="dark-light-buttons"
        />
    );
};

export default DarkLight;
